"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quoteString = void 0;
const quoteString = (filterString) => {
    return /\s+/.test(filterString) ? `'${filterString}'` : filterString;
};
exports.quoteString = quoteString;
//# sourceMappingURL=quoteString.js.map